import { withStyles } from "@material-ui/core";
import React , { useState } from "react";
import styles from "./styles";
import { Container } from "@material-ui/core/";
import logo from "../../assets/images/logo.png";
import Zalo from "../../assets/images/zalo-1.svg";
import Skype from "../../assets/images/skype-icon.svg";
import Facebook from "../../assets/images/facebook-messenger.svg";
import { NavLink } from "react-router-dom";
import { FiPhoneCall, FiMail, FiSearch } from "react-icons/fi";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { ArrowDropDown } from "@material-ui/icons";

import { TiMessages } from "react-icons/ti";
import { IoIosArrowDown } from "react-icons/io";

import { routes } from "../../routes";

function Header(props) {

  const [displayChild, setDisplayChild] = useState(null);
  const [displayContact, setDisplayContact] = useState(false);

  const { classes, categoryChild, setDisplaySearchAction, displayShowSearch, setKeySearchAction } = props;

  const [showMenu, setMenu] = useState(false);
  const [searchKeyState, setSearchKeyState] = useState('');

  const renderCateChild = cateParent => {
    let result = null;

    if (categoryChild && categoryChild.length > 0) {
      result = categoryChild.map(
        item =>
          cateParent === item.cateParent && (
            <li
              key={
                item.cateParent === "project"
                  ? `project-${item.id}`
                  : `news-${item.id}`
              }
            >
              <NavLink
                to={{
                  pathname: item.cateParent === "project"
                    ? `/du-an/${item.alias}`
                    : `/tin-tuc/${item.alias}`,
                  state: { item }
                }}
                exact
              >
                {item.name}
              </NavLink>
            </li>
          )
      );
    }

    return result;
  };

  const renderMenu = () => {
    return routes.map((item, index) => {
      return (
        <li key={item.id}>
          <NavLink to={item.path} exact={item.exact} onClick={() => handleClick(index)}>
            {item.name}
            {item.exact && item.path !== "/" ? <IoIosArrowDown /> : null}
          </NavLink>
          {item.exact && item.path !== "/" ? (
            <>
              <ul className={displayChild === index ? 'show-child' : ''}>{renderCateChild(item.cateParentName)}</ul>
            </>
          ) : null}
        </li>
      );
    });
  };
  
  function handleClick(index){
    if(window.innerWidth < 765){
      setDisplayChild(index === displayChild ? null : index);
    }
  }

  const showSearchDisplay = () =>{
    setDisplaySearchAction();
  }
  
  const showContact = () => {
    setDisplayContact(!displayContact);
  }

  const handleChange = event => {
    const value = event.target.value;
    setSearchKeyState(value);
  }

  const searchClick = () => {
    setKeySearchAction(searchKeyState);
  }

  const submitHandler = (e) => {
    e.preventDefault();
    props.history.push('/search');
    searchClick();
  }

  return (
    <>
      <div>
        <Container className={classes.headerTop} maxWidth="xl">
          <div className={classes.headerTopLeft}>
            <NavLink to="/">
              <img className={classes.logo} src={logo} alt="logo" />
            </NavLink>
          </div>
          <div className={classes.headerTopRight}>
            <div className={classes.headerContact}>
              <FiPhoneCall className="header-top-icon" />
              <div>
                <h5>Hotline tư vấn:</h5>
                <h3>
                  <a href="tel:093 769 2208">093 769 2208</a>
                </h3>
              </div>
            </div>

            <div className={classes.headerContact}>
              <FiMail className="header-top-icon" />
              <div>
                <h5>Email hỗ trợ:</h5>
                <h3>
                  <a href="mailto:wasthtech@gmail.com">wasthtech@gmail.com</a>
                </h3>
              </div>
            </div>

            <div className={classes.headerContact}>
              <TiMessages className="header-top-icon" />
              <div onClick={showContact}>
                <h5>Chat với chúng tôi:</h5>
                <h3>
                  <a href="#/">Chat qua liên kết</a>
                  <ArrowDropDown />
                </h3>
              </div>
              <ul className={displayContact ? 'show' : 'hidden'}>
                <li>
                  <a href="https://zalo.me/0937692208">
                    <img alt="img" src={Zalo}></img>
                    093 769 2208 Mr. Hiển
                    </a>
                </li>
                <li>
                  <a href="skype:hien_phan18386?chat">
                    <img alt="img" src={Skype}></img>
                    Skype
                  </a>
                </li>
                <li>
                  <a href="https://m.me/100204468473353">
                  <img alt="img" src={Facebook}></img>
                    Facebook message
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </div>

      <div className={classes.headerBottom}>
        <Container className="container" maxWidth="xl">
          <div className={`${classes.menu} active`}>
            <ul className={showMenu ? "mobile-active" : ""}>{renderMenu()}</ul>
            {showMenu && <div onClick={() => setMenu(false)} className={classes.overlayMenu} />}
            <button onClick={() => setMenu(true)} className={classes.sidebarBtn}>
              <span href=""></span>
            </button>
          </div>

          <NavLink to="/">
            <img className={classes.logoMobile} src={logo} alt="logo" />
          </NavLink>
        
          <div className={classes.headerBottomRight}>
            <div className={classes.searchButton}>
              <button onClick={showSearchDisplay}>
                  <FiSearch />
              </button>
            </div>
            <div className={`${classes.searchHeader} ${displayShowSearch ? "active":""}`}>
              <div className={classes.arrowUp}></div>
              <form onSubmit={submitHandler} >
                <input type="text" placeholder="Nhập từ khoá" onChange={handleChange}/>
                <button onClick={searchClick}>
                  <NavLink
                    to="/search"
                  >
                    <FiSearch />
                  </NavLink>
                </button>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default compose(withStyles(styles), withRouter)(Header);
